import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function WelcomeScreen({ appState, updateState }) {
  const [tosAccepted, setTosAccepted] = useState(false);
  const navigate = useNavigate();

  const handleCreateWallet = () => {
    updateState({ isCreatingNew: true });
    navigate("/network-selection");
  };

  const handleImportWallet = () => {
    updateState({ isCreatingNew: false });
    navigate("/network-selection");
  };

  return (
    <div className="screen">
      <div className="progress-dots">
        <div className="dot active"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>

      <div className="logo-container">
        <div className="logo-placeholder">
          <div className="logo-icon">🎒</div>
        </div>
      </div>

      <h1 className="title">Welcome to Backpack</h1>
      <p className="subtitle">{"You'll use this wallet to send and receive crypto and NFTs"}</p>

      <div className="tos-container">
        <label className="tos-checkbox">
          <input type="checkbox" checked={tosAccepted} onChange={(e) => setTosAccepted(e.target.checked)} />
          <span className="checkmark"></span>I agree to the{" "}
          <a href="#" className="tos-link">Terms of Service</a>.
        </label>
      </div>

      <div className="button-container">
        <button
          className={`primary-button ${!tosAccepted ? "disabled" : ""}`}
          disabled={!tosAccepted}
          onClick={handleCreateWallet}
        >
          Create a new wallet
        </button>
        <button
          className={`secondary-button ${!tosAccepted ? "disabled" : ""}`}
          disabled={!tosAccepted}
          onClick={handleImportWallet}
        >
          I already have a wallet
        </button>
      </div>
    </div>
  );
}